import moment from 'moment';
import countriesTreater from '../components/ProfilesTabs/helpers/countriesTreater';

export function createTypes(
  base: string,
  types: string[] = ['REQUEST', 'SUCCESS', 'REJECTED'],
): Record<string, string> {
  return types.reduce(
    (acc, type) => {
      acc[type] = `${base}_${type}`;
      return acc;
    },
    {} as Record<string, string>,
  );
}
export function createSyncActions(actionType) {
  return {
    request: () => ({ type: actionType.REQUEST }),
    success: payload => ({ type: actionType.SUCCESS, payload }),
    rejected: (payload = {}) => ({ type: actionType.REJECTED, payload }),
  };
}
export function createDatesArray(dates) {
  // eslint-disable-next-line @typescript-eslint/no-array-constructor
  const date: any[] = [];
  let startDate = dates.start;
  do {
    date.push(moment(startDate, 'YYYY-MM-DD'));
    startDate = moment(startDate).add(1, 'days');
  } while (startDate <= moment(dates.end));
  return date;
}

export function actionListener(store, actionType, callBack) {
  return store.subscribe(function () {
    const action = store.getState().LastAction;

    if (action.type === actionType) {
      callBack(action);
    }
  });
}

export const propertyToggle = (validator, trueAnswer, falseAnswer) =>
  validator || validator === 0 ? trueAnswer : falseAnswer;

export function cleanDefaultString(object = {}, defaulString) {
  const cleaned = {};
  for (const key in object) {
    cleaned[key] = propertyToggle(
      object[key] !== defaulString && object[key] !== 'GLOBAL',
      object[key],
      '',
    );
  }
  return cleaned;
}

export function cleanEmptyString(object = {}) {
  const cleaned = {};
  for (const key in object) {
    cleaned[key] = propertyToggle(object[key], object[key], null);
  }
  return cleaned;
}

export function paginationCountLabel(from, to, count, of) {
  return `${from}-${to} ${of} ${count}`;
}
export function getDefaultLabel(
  state: string,
  country: string,
  region: string,
  countries,
  states,
) {
  return state === 'all'
    ? country === 'all'
      ? region === 'all'
        ? 'Default'
        : region
      : countriesTreater(countries).find(el => el.id === country)?.name
    : states?.find(s => s.id === state)?.description;
}

/**
 * Wraps equipment availabilities into string of arrays to prepare
 * the call for endpoint getEquipmentAvailabilities
 * @param {Object} object
 * @returns {Object}
 */
export function wrapEquipmentAvailabilities(object = {}) {
  const wrapped = {};
  for (const [key, value] of Object.entries(object)) {
    wrapped[key] =
      key === 'region' && Array.isArray(value)
        ? `[${value}]`
        : key === 'region' && value !== ''
          ? `["${value}"]`
          : key === 'country' && value !== ''
            ? `[${value}]`
            : key === 'state' && value !== ''
              ? `[${value}]`
              : value;

    if ((key === 'country' || key === 'state') && value === 'all')
      wrapped[key] = null;
  }
  return wrapped;
}

/**
 * Creates an object for region, country and state with values of
 * equipment_availabilities into an array
 * @param {Array} availabilities
 * @returns {Object}
 */
export function groupAvailabilities(availabilities: any) {
  const prev = {};
  prev['region'] =
    availabilities
      .filter(
        entity => entity.region_id !== null && entity.region_id !== undefined,
      )
      .map(region => `"${region.region_id}"`) || '';
  prev['country'] =
    availabilities
      .filter(
        entity => entity.country_id !== null && entity.country_id !== undefined,
      )
      .map(country => country.country_id) || '';
  prev['state'] =
    availabilities
      .filter(
        entity => entity.state_id !== null && entity.state_id !== undefined,
      )
      .map(state => state.state_id) || '';
  return uniqueEntities(prev);
}

/**
 * Clean arrays inside an object and convert empty array into string ""
 * i.e
 *  {
 *    region: ["APAC", "LAC", "APAC"]
 *    country: [123, 124, 123],
 *    state: []
 *  }
 * returning
 * {
 *    region: ["APAC", "LAC"]
 *    country: [123, 124],
 *    state: ""
 * }
 * @param {object}
 *
 * @returns {object}
 */
export function uniqueEntities(object = {}) {
  const prev = {};
  for (const [key, value] of Object.entries<any>(object)) {
    prev[key] = value.filter(
      (elem, index, self) => index === self.indexOf(elem),
    );
  }
  // if there are empty arrays, convert to a string ""
  Object.keys(prev).forEach(
    k => (prev[k] = prev[k].length >= 1 ? prev[k] : ''),
  );
  return prev;
}

export function toCamelCase(str) {
  return str
    .toLowerCase()
    .replace(/[\s-_](.)/g, function ($1) {
      return $1.toUpperCase();
    })
    .replace(/[\s-_]/g, '')
    .replace(/^(.)/, function ($1) {
      return $1.toLowerCase();
    });
}

/**
 * Calculate the delivery time open and close, depending on flag isOpenTime,
 * If it's true, then calculate delivery time open adding to currentTime, in case
 * isOpenTime flag is equals to false, then calculate delivery time close, subtracting
 * from currentTime the time value.
 *
 * @param currentTime <String>
 * @param time <String>
 * @param isOpenTime <boolean>
 * @returns {String}
 */
export function calculateDeliveryTimeBase({
  currentTime = '00:00',
  time = '00:00',
  isOpenTime = false,
  minimumOpeningTime = '00:00',
}) {
  if (currentTime === '' && !isOpenTime) {
    return '';
  }

  const timeToCalculate = moment(currentTime, 'HH:mm');
  const modifierTime = moment(time, 'HH:mm');
  const minimumOpeningTimeFormated = moment(minimumOpeningTime, 'HH:mm');

  let deliveryTime = isOpenTime
    ? timeToCalculate.add({
        hours: modifierTime.hour(),
        minutes: modifierTime.minute(),
      })
    : timeToCalculate.subtract({
        hours: modifierTime.hour(),
        minutes: modifierTime.minute(),
      });

  if (
    isOpenTime &&
    minimumOpeningTimeFormated &&
    deliveryTime < minimumOpeningTimeFormated
  ) {
    deliveryTime = minimumOpeningTimeFormated;
  }

  return deliveryTime.format('HH:mm');
}
export const toMinutes = time => {
  if (!time) return 0;
  const [hours, minutes] = time.split(':').map(n => Number(n));
  return 60 * hours + minutes;
};

export const canSeeDeliveryRow = (permissions = [''], role) => {
  if (role !== 'R_RM') return true;
  const isCorporateUser = isCorporateAdmin();

  const hasEditDeliveryPermission = permissions.includes(
    'P_RAM_EDIT_OP_HOURS__DELIVERY',
  );
  return hasEditDeliveryPermission || isCorporateUser;
};
export const validateHourRange = (startTime, endTime, deltaMinutes) => {
  if (!startTime && !endTime) return true;
  if ((startTime && !endTime) || (!startTime && endTime)) return false;

  const startTimeMinutes = toMinutes(startTime);
  let endTimeMinutes = toMinutes(endTime);

  if (endTimeMinutes < startTimeMinutes) {
    endTimeMinutes += 24 * 60;
  }

  return endTimeMinutes - startTimeMinutes >= deltaMinutes;
};

export function isCorporateAdmin() {
  let Profile: any = localStorage.getItem('profile') || '';
  try {
    if (Profile) {
      Profile = JSON.parse(Profile);
    }
  } catch (error) {
    return false;
  }
  return Profile?.userType === 'corporate_admin';
}
